import React from 'react';

import {
    calculatePercentSharesDetails,
    getCompositeEntityKey,
    locale,
} from '@trqk/utils';

import { OwnershipSection } from '.';

const getOwnershipGroups = (
    entity: TrqkEntity,
    percent_shares: ProEntityPercentShare[],
    trqkSongId: string,
    title: string,
): {
    admin: WorkDetailPercentShare[];
    publisher: WorkDetailPercentShare[];
    unknown: WorkDetailPercentShare[];
    writer: WorkDetailPercentShare[];
} => {
    const result = {
        admin: [] as WorkDetailPercentShare[],
        publisher: [] as WorkDetailPercentShare[],
        unknown: [] as WorkDetailPercentShare[],
        writer: [] as WorkDetailPercentShare[],
    };

    const { pro, name, role_type } = entity;

    const ownerDetails = {
        pro,
        name,
        roleType: role_type,
    };

    const ownerKey = getCompositeEntityKey(ownerDetails);

    percent_shares.forEach((percent_share: ProEntityPercentShare): void => {
        const { entity_name, entity_pro, entity_role_type } = percent_share;
        const key = getCompositeEntityKey({
            name: entity_name,
            pro: entity_pro,
            roleType: entity_role_type,
        });

        if (ownerKey !== null && ownerKey === key) {
            result[entity_role_type].unshift({
                ...percent_share,
                sendInvite: false,
                trqkSongId,
                title,
                key,
            });
        } else if (key !== null) {
            result[entity_role_type].push({
                ...percent_share,
                sendInvite: false,
                trqkSongId,
                title,
                key,
            });
        }
    });

    const { unknownShares } = calculatePercentSharesDetails(percent_shares);

    if (unknownShares !== 0) {
        const writerDetails = {
            entity_id: 'unknown-entity',
            name: locale.enUS.INVITE_WRITER,
            pro: locale.enUS.INVITE_PRO,
            roleType: 'writer' as ProRoleType,
        };

        const writerKey = getCompositeEntityKey(writerDetails);

        if (writerKey) {
            result.writer.splice(1, 0, {
                entity_id: writerDetails.entity_id,
                entity_name: writerDetails.name,
                entity_pro: writerDetails.pro,
                entity_role_type: writerDetails.roleType,
                percent_share: unknownShares,
                key: writerKey,
                sendInvite: true,
                title,
                trqkSongId,
            });
        }
    }

    return result;
};

interface Props {
    entity: TrqkEntity;
    percent_shares: ProEntityPercentShare[];
    title: string;
    trqkSongId: string;
}

export const Ownership = ({
    entity,
    percent_shares,
    title,
    trqkSongId,
}: Props): JSX.Element => {
    const ownershipGroups = getOwnershipGroups(
        entity,
        percent_shares,
        trqkSongId,
        title,
    );

    return (
        <div className="my-6 flex track-detail-column">
            <div className="w-1/2 border-r border-tertiary-200 mr-2">
                <OwnershipSection
                    roleType={'writer' as ProRoleType}
                    shares={ownershipGroups.writer}
                />
            </div>
            <div className="w-1/2 ml-2">
                <OwnershipSection
                    roleType={'publisher' as ProRoleType}
                    shares={ownershipGroups.publisher}
                />
            </div>
        </div>
    );
};
